<template>
  <div>
    <el-dialog
      class="basic_deleteType"
      :title="$t('view_god_set_index_226')"
      :visible.sync="show_pop"
      append-to-body
      width="500px"
      @close="handleClose"
      :close-on-click-modal="false"
    >
      <p>{{$t('components_basic_deletetype_index_2174')}}</p>
      <div v-if="IDData.length > 0">
        <p v-if="checked">{{$t('components_basic_deletetype_index_2175')}}</p>
        <div v-else class="unCheck">
          <span>{{$t('components_basic_deletetype_index_2176', [ type ])}}</span>
          <div class="selectPart">
            <div class="fifter_tree">
              <div class="open_layer my_layer" v-show="!fifterTree" @click="showTree"></div>
              <div class="close_layer my_layer" v-show="fifterTree" @click="fifterTree = false"></div>
              <div class="fifter_down">
                <el-input
                  v-model="type_name"
                  :clearable="true"
                  :placeholder="$t('components_basic_addproduct_message_2101')"
                  @focus="showTree"
                  @clear="cleanFifter"
                  @blur="hiddenTree"
                >
                  <i v-show="!fifterTree" slot="suffix" class="el-input__icon el-icon-arrow-down" />
                  <i v-show="fifterTree" slot="suffix" class="el-input__icon el-icon-arrow-up" />
                </el-input>
              </div>
              <transition name="slide-fade">
                <el-scrollbar v-show="fifterTree" class="scroll_tree">
                  <div v-show="fifterTree" class="fifter_up org_tree org_tree_fifter">
                    <el-tree
                      ref="tree2"
                      :data="popTreedata"
                      :props="defaultProps"
                      :filter-node-method="filterNode"
                      :expand-on-click-node="false"
                      :default-expand-all="true"
                      class="filter-tree"
                      @node-click="choseOrg"
                    />
                  </div>
                </el-scrollbar>
              </transition>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <div class="checkouts">
          <el-checkbox v-if="IDData.length > 0" v-model="checked">{{$t('components_basic_deletetype_index_2177')}}</el-checkbox>
        </div>
        <div class="btns">
          <el-button type="primary" @click="changeListtype">{{$t('view_public_topbar_15')}}</el-button>
          <el-button @click="handleClose">{{$t('view_public_topbar_14')}}</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import i18n from '../../language/index'

import { getIDlist, changeListtype, deltypeList, deleteArtical, deletePro, deleteProType, delete_atlas } from '@/api/app.js';
export default {
  props: {
    showPop: {
      type: Boolean,
      default: false
    },
    //内容管理 内容分类区别id
    typeId: {
      type: Number,
      default: 1
    },
    //区分产品管理 还是内容管理 1为产品管理 2位内容管理
    typeValue: {
      type: Number,
      default: 1
    },
    //选择的分类id
    checkID: {
      type: Number,
      default: null
    },
    //分类列表
    popTreedata: {
      type: Array,
      default: function () {
        return [];
      }
    }
  },
  data () {
    return {
      show_pop: this.showPop,
      checked: true,
      fifterTree: false,
      IDData: {},
      tree_data: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      type_name: '',
      type_number: null
    };
  },
  computed: {
    type () {
      if (this.typeValue == 1) {
        return i18n.t('widgets_basic_classification_edit_482')
      } else {
        //文章删除步骤 先批量删除文章再删除分类
        if (this.typeId === 5) {
          return i18n.t('components_basic_addarticle_index_2010')
        } else {
          return i18n.t('base_options_config_1732')
        }
      }
      return ''
    }
  },
  watch: {
    show_pop (val) {
      if (val) {
        this.getIDlist();
      }
      this.$emit('update:showPop', val);
    },
    showPop (val) {
      this.show_pop = val;
    }
  },
  mounted () { },
  methods: {
    deleteType () {
      //产品删除步骤 先批量删除产品再删除分类
      if (this.typeValue == 1) {
        this.deletePro()
      } else {
        //文章删除步骤 先批量删除文章再删除分类
        if (this.typeId === 5) {
          this.delateAlbum()
        } else {
          this.deleteArtical()
        }
      }
    },
    deleteArtical () {
      let deleteList = {
        ids: this.IDData.join(','),
        type:this.typeId // 删除分类的时候 提示 缺少参数修改 传递type
      };
      let deleteType = {
        id: this.checkID,
      };
      if (this.IDData.length > 0) {
        deleteArtical(deleteList)
          .then(res => {
            if (res.code == 200) {
              deltypeList(deleteType)
                .then(res => {
                  if (res.code == 200) {
                    this.handleClose();
                  } else {
                    this.$message.error(res.message);
                  }
                  console.log(res);
                })
                .catch(error => { })
                .finally();
            } else {
              this.$message.error(res.message);
            }
          })
          .catch(error => { })
          .finally();
      } else {
        deltypeList(deleteType)
          .then(res => {
            if (res.code == 200) {
              this.handleClose();
            } else {
              this.$message.error(res.message);
            }
            console.log(res);
          })
          .catch(error => { })
          .finally();
      }
    },
    deletePro () {
      let deleteList = {
        ids: this.IDData.join(',')
      };
      let deleteType = {
        id: this.checkID
      };
      if (this.IDData.length > 0) {
        deletePro(deleteList)
          .then(res => {
            if (res.code == 200) {
              deleteProType(deleteType)
                .then(res => {
                  if (res.code == 200) {
                    this.handleClose();
                  } else {
                    this.$message.error(res.message);
                  }
                  console.log(res);
                })
                .catch(error => { })
                .finally();
            } else {
              this.$message.error(res.message);
            }
          })
          .catch(error => { })
          .finally();
      } else {
        deleteProType(deleteType)
          .then(res => {
            if (res.code == 200) {
              this.handleClose();
            } else {
              this.$message.error(res.message);
            }
            console.log(res);
          })
          .catch(error => { })
          .finally();
      }
    },
    delateAlbum () {
      let deleteList = { ids: this.IDData.join(',') }
      let deleteType = { id: this.checkID }
      if (this.IDData.length > 0) {
        delete_atlas(deleteList)
          .then(res => {
            if (res.code == 200) {
              deltypeList(deleteType)
                .then(res => {
                  if (res.code == 200) {
                    this.handleClose();
                  } else {
                    this.$message.error(res.message);
                  }
                  console.log(res);
                })
                .catch(error => { })
                .finally();
            } else {
              this.$message.error(res.message);
            }
          })
          .catch(error => { })
          .finally();
      } else {
        deltypeList(deleteType)
          .then(res => {
            if (res.code == 200) {
              this.handleClose();
            } else {
              this.$message.error(res.message);
            }
            console.log(res);
          })
          .catch(error => { })
          .finally();
      }
    },
    changeListtype () {
      if (!this.checked && !this.type_name) {
        this.$message.error(i18n.t('components_basic_deletetype_index_2178'));
        return false;
      }
      let data = {};
      if (!this.checked) {
        data.type = this.typeValue == 1 ? 'goods' : this.typeId === 5 ? 'album' : 'article'
        data.ids = this.IDData.join(',')
        data.cate_id = this.type_number
        changeListtype(data)
          .then(res => {
            if (res.code == 200) {
              let deleteType = {
                id: this.checkID
              };
              if (this.typeValue == 1) {
                deleteProType(deleteType)
                  .then(res => {
                    if (res.code == 200) {
                      this.handleClose();
                    } else {
                      this.$message.error(res.message);
                    }
                    console.log(res);
                  })
                  .catch(error => { })
                  .finally();
              } else {
                //文章删除步骤 先批量删除文章再删除分类
                deltypeList(deleteType)
                  .then(res => {
                    if (res.code == 200) {
                      this.handleClose();
                    } else {
                      this.$message.error(res.message);
                    }
                    console.log(res);
                  })
                  .catch(error => { })
                  .finally();
              }
            } else {
              this.$message.error(res.message);
            }
            console.log(res);
          })
          .catch(error => { })
          .finally();
      } else {
        this.deleteType()
      }
    },
    getIDlist () {
      // 1:文章 2:帮助 3:案例 4:下载 11:视频,5:图册,0:产品
      let data = {
        type: this.typeValue == 1 ? 'goods' : this.typeId === 5 ? 'album' : 'article',
        cate_id: this.checkID
      }
      getIDlist(data)
        .then(res => {
          if (res.code == 200) {
            this.IDData = res.data;
          } else {
            this.$message.error(res.message);
          }
          console.log(res);
        })
        .catch(error => { })
        .finally();
    },
    handleClose () {
      this.show_pop = false;
      this.checked = true;
      this.fifterTree = false;
      this.$emit('getNewTypeList');
    },
    showTree () {
      this.fifterTree = true;
      this.$refs.tree2.filter('false');
    },
    cleanFifter () {
      //this.is_clean = true
    },
    hiddenTree () {
      this.fifterTree = false;
    },
    choseOrg (val) {
      this.type_name = val.name;
      this.type_number = val.id;
      this.fifterTree = false;
    },
    filterNode (value, data) {
      if (!value) return true;
      return data.id !== this.checkID;
      // return true;
    }
  }
};
</script>

<style lang="scss" scoped>
.basic_deleteType {
  /deep/ .el-dialog__footer {
    .dialog-footer {
      .checkouts {
        margin-bottom: 10px;
        text-align: center;
        .el-checkbox {
          // position: absolute;
          // left: 20px;
          // bottom: 25px;
        }
      }
      .btns {
        text-align: center;
        .el-button {
          margin: 8px 18px;
        }
      }
    }
  }
}
.selectPart {
  position: relative;
  display: inline-block;
  width: 40%;
  vertical-align: top;
}

p {
  text-align: center;
  line-height: 26px;
}
.unCheck {
  text-align: center;
  margin-top: 10px;
}
.unCheck > span {
  vertical-align: top;
  line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/basic_deleteType/index.vue